import { render, staticRenderFns } from "./publication_field.vue?vue&type=template&id=756bb48a&lang=pug"
import script from "./publication_field.vue?vue&type=script&lang=js"
export * from "./publication_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports